import {
  Avatar,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  styled,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useEffect, useState } from "react";
import SessionStorageService from "../services/StorageService";
import SicilBilgileriListeleAPI from "../apis/OB/Get/SicilBilgileriListeleAPI";

const StyledCard = styled(Card)(({ theme }) => ({
  marginTop: theme.spacing(4),
  padding: theme.spacing(2),
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(10),
  height: theme.spacing(10),
  backgroundColor: theme.palette.primary.main,
}));

const GridItem = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const SicilBilgileri = () => {
  const user = SessionStorageService.getUserInfo();
  const [sicilData, setSicilData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchSicilBilgileri = async () => {
      try {
        let tcKimlikNo: string | undefined = undefined;
        let vergiNo: string | undefined = undefined;

        if (user?.vergiNo) {
          vergiNo = user.vergiNo.toString();
        } else if (user?.tcKimlikNo) {
          tcKimlikNo = user.tcKimlikNo.toString();
        }

        const res = await SicilBilgileriListeleAPI.getSicilBilgileriListe(
          undefined,
          tcKimlikNo,
          vergiNo
        );

        if (res.success) {
          setSicilData(res.data[0]);
        } else {
          setError(true);
        }
      } catch (e) {
        console.error("Sicil bilgileri alınırken hata oluştu:", e);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchSicilBilgileri();
  }, []);

  if (loading) {
    return (
      <Container>
        <CircularProgress />
      </Container>
    );
  }

  if (error || !sicilData) {
    return (
      <Container>
        <Alert severity="error">Bilgiler alınamadı.</Alert>
      </Container>
    );
  }

  return (
    <Container>
      <StyledCard>
        <CardContent>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              lg={1}
              display="flex"
              justifyContent="start"
            >
              <StyledAvatar>
                {/* <img
                  style={{ scale: "0.2" }}
                  src="https://res.cloudinary.com/demo/image/twitter/1330457336.jpg"
                  alt=""
                /> */}
              </StyledAvatar>
            </Grid>
            <Grid item xs={12} sm={10} md={10} lg={11}>
              <Typography variant="h5">
                {sicilData.adi || "-"} {sicilData.soyadi || "-"}
              </Typography>
              <Typography variant="subtitle1" color="textSecondary">
                {sicilData.unvani || "Unvan Yok"}
              </Typography>
            </Grid>
            <GridItem item xs={12}>
              <Typography variant="body1">
                <strong>Sicil Kodu:</strong> {sicilData.sicilKodu || "-"}
              </Typography>
            </GridItem>
            <GridItem item xs={12}>
              <Typography variant="body1">
                <strong>TC Kimlik No:</strong> {sicilData.tcKimlikNo || "-"}
              </Typography>
            </GridItem>
            <GridItem item xs={12}>
              <Typography variant="body1">
                <strong>Vergi No:</strong> {sicilData.vergiNo || "-"}
              </Typography>
            </GridItem>
            <GridItem item xs={12}>
              <Typography variant="body1">
                <strong>Adres:</strong> {sicilData.iletisimAdresi || "-"}
              </Typography>
            </GridItem>
            <GridItem item xs={12}>
              <Typography variant="body1">
                <strong>Email:</strong> {sicilData.ePostaAdresi || "-"}
              </Typography>
            </GridItem>
            <GridItem item xs={12}>
              <Typography variant="body1">
                <strong>Doğum Yeri:</strong> {sicilData.dogumYeri || "-"}
              </Typography>
            </GridItem>
            <GridItem item xs={12}>
              <Typography variant="body1">
                <strong>Doğum Tarihi:</strong>{" "}
                {sicilData.dogumTarihi
                  ? new Date(sicilData.dogumTarihi).toLocaleDateString()
                  : "-"}
              </Typography>
            </GridItem>
            <GridItem item xs={12}>
              <Typography variant="body1">
                <strong>Baba Adı:</strong> {sicilData.babaAdi || "-"}
              </Typography>
            </GridItem>
            <GridItem item xs={12}>
              <Typography variant="body1">
                <strong>Anne Adı:</strong> {sicilData.anneAdi || "-"}
              </Typography>
            </GridItem>
            <GridItem item xs={12}>
              <Typography variant="body1">
                <strong>Cep Telefonu:</strong> {sicilData.cepTelefonu || "-"}
              </Typography>
            </GridItem>
            <GridItem item xs={12}>
              <Typography variant="body1">
                <strong>Sabit Telefon:</strong> {sicilData.sabitTelefon || "-"}
              </Typography>
            </GridItem>
            <GridItem item xs={12}>
              <Typography variant="body1">
                <strong>Vergi Dairesi:</strong> {sicilData.vergiDaire || "-"}
              </Typography>
            </GridItem>
          </Grid>
        </CardContent>
      </StyledCard>
    </Container>
  );
};

export default SicilBilgileri;
